




























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import TaskApi from '@/api/task'
import echarts from 'echarts/index.common'
import 'echarts/map/js/china.js'

@Component({
	components: {
		PageLayout,
	},
})
export default class RelationsOrders extends Vue {
	@Prop()
	private resurveyOrder!: any

	private area: any = []

	private currentArea = -1

	private inputArea = ''

	private resultArea: any = []

	private async created() {
		const res = await TaskApi.getVisitorAreaDistribution('')
		const data = res.data
		this.area = data
		this.resultArea = data
		this.renderMap(data)
	}

	private toggleDetail(index: number) {
		if (this.currentArea === index) {
			this.currentArea = -1
		} else {
			this.currentArea = index
		}
	}

	private onClear() {
		this.inputArea = ''
		this.resultArea = this.area
	}

	private onSearch() {
		this.currentArea = -1
		let reg = new RegExp(this.inputArea)
		this.resultArea = this.area.filter((item: any) => {
			return this.searchArea(item, reg)
		})
		if (this.resultArea && this.resultArea.length) {
			this.currentArea = 0
		}
	}

	private searchArea(area: any, reg: RegExp) {
		if (area.areaName && area.areaName.match(reg)) {
			return true
		}
		let res = ''
		res =
			area.children &&
			area.children.find((item: any) => {
				return this.searchArea(item, reg)
			})
		return res
	}

	private renderMap(data: any) {
		this.$nextTick(() => {
			const map = document.getElementById('map')
			if (!map) {
				return
			}
			var myChart = echarts.init(map)
			const option = {
				title: {
					text: '作业覆盖区域',
				},
				series: [
					{
						type: 'map',
						map: 'china',
						label: {
							show: true,
						},
						silent: true,
						emphasis: {
							itemStyle: {
								areaColor: '#0064DC',
							},
						},
						data: data.map((item: any) => {
							let name = ''
							if (['黑龙江', '内蒙古'].includes(item.areaName.slice(0, 3))) {
								name = item.areaName.slice(0, 3)
							} else {
								name = item.areaName.slice(0, 2)
							}
							return {
								name,
								selected: true,
							}
						}),
					},
				],
			}

			myChart.setOption(option)
		})
	}
}
